//Vectorworks GDPR Alert Consent Functionality

$(document).on('click', '.gdpr-consent-opt', function(e) {

    e.preventDefault();

    var opt_val = $(this).data('value');

    var isBannerConsent = true; //default is banner consent shown on init

    if($(this).closest('#gdprAlert').length === 0) {
        isBannerConsent = false;
    }

    if(opt_val) {
        $.post('/cs/ajax/gdpr-consent-' + opt_val, function() {
            if(isBannerConsent) {
                //close GDPR banner
                $('#gdprAlert').fadeOut('slow', function() {
                    $(this).remove();
                });

                //Only redirect if Declined
                if(opt_val == 'decline') {
                    window.location.reload(true);
                }
            } else {
                //show confirmation message
                var consentParentElement = $(this).parent();
                var opt_copy = (opt_val == 'accept') ? 'accepted' : 'declined';
                var conf_msg = $('<div id="gdpr-ck-consent-alert" class="gdpr-ck-consent-alert alert alert-success" style="display:none; border: none !important; font-weight: bold; border-radius:0;">You have ' + opt_copy + ' the use of cookies. If you’d like to change your cookie preferences in the future, you may do so below. </div>');
                consentParentElement.find('#gdpr-ck-consent-alert').remove();
                consentParentElement.prepend(conf_msg);
                conf_msg.fadeIn('slow');

                //Redirect for both Accept and Decline
                window.location.reload(true);
            }
        });
    }

});